module.exports = __webpack_public_path__ + "static/img/emergencyBroadcast.f3b10da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/top/emergencyBroadcast.png
// module id = oaQW
// module chunks = 24